import * as React from "react";
import { DrupalDogDetailPage } from "../../dog";

export interface IDrupalBroodRequestNewFatherFormProps {
  selectedIds: number[];
  setVisible: any;
  setSelectedIds: any;
  motherId: number;
}

export const DrupalBroodRequestNewFatherForm: React.FunctionComponent<IDrupalBroodRequestNewFatherFormProps> = ({
  selectedIds,
  setVisible,
  setSelectedIds,
  motherId,
}) => {
  const postSave = React.useCallback(
    (newDogId: number) => {
      console.log("post update");
      selectedIds.push(newDogId);
      setSelectedIds([...selectedIds]);
      setVisible(false);
    },
    [selectedIds, setSelectedIds, setVisible]
  );
  return (
    <DrupalDogDetailPage
      isCreationPopUp={true}
      readonlySex={true}
      postSaveFunc={postSave}
      withoutOwner={true}
      motherId={motherId}
      isSportSection={false}
    />
  );
};
